/**
 * Centralized access to the current PLATFORM brand (Dukakit vs Shara360),
 * injected server-side as window.platformBrand (see
 * resources/views/layouts/app.blade.php + App\Services\PlatformBrand).
 *
 * This is platform branding ONLY — never mix in company/product/user data
 * here. Components read it via `this.$platformBrand`, e.g.
 * `this.$platformBrand.logoUrl`, never a generic `logo`.
 */
const platformBrand = window.platformBrand || {
    key: 'dukakit',
    name: 'Dukakit',
    shortName: 'Dukakit',
    websiteUrl: 'https://dukakit.com',
    appUrl: 'https://app.dukakit.com',
    supportEmail: 'support@dukakit.com',
    businessEmail: 'business@dukakit.com',
    salesEmail: 'sales@dukakit.com',
    logoUrl: '/images/DukaKitlogotr.png',
    logoLightUrl: '/images/logo.png',
    logoDarkUrl: '/images/DukaKitlogotr.png',
    faviconUrl: '/images/favicon.png',
    themeColor: '#fd4719',
};

export default {
    install(Vue) {
        Vue.prototype.$platformBrand = platformBrand;
    },
};

export { platformBrand };
